import React, { useState, useEffect } from 'react';
import { MessageCircleWarning, Zap } from 'lucide-react';
import WelcomeModal from './WelcomeModal';
import { isKariBday } from '../utils/dateUtils';

const BDAY_MODAL_KEY = "ks_bday_modal_seen";

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isKariBday()) {
      const today = new Date().toISOString().slice(0, 10);
      if (localStorage.getItem(BDAY_MODAL_KEY) !== today) {
        setIsModalOpen(true);
      }
    }
  }, []);

  const handleClose = () => {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem(BDAY_MODAL_KEY, today);
    setIsModalOpen(false);
  };

  return (
    <>
      <footer className="w-full bg-white border-t border-gray-200 p-4 font-quicksand relative">
        <div className="flex items-center justify-center">
          <Zap size={16} className="text-gray-600 mr-1" fill="currentColor" />
          <p className="text-gray-600 text-sm">Powered by Mely</p>
        </div>
        <div className="absolute right-4 top-1/2 transform -translate-y-1/2 flex items-center">
          <button onClick={() => setIsModalOpen(true)} className="flex items-center justify-center">
            <MessageCircleWarning size={27} strokeWidth={2.5} className="text-[#ff69b4]" />
          </button>
        </div>
      </footer>

      {isModalOpen && (
        <WelcomeModal onClose={() => handleClose()} />
      )}
    </>
  );
};

export default Footer;
